import { Action, createReducer, on } from '@ngrx/store';
import {
  UpdateIncomeNetWorth,
  UpdateIncomeNetWorthValidationStatus,
} from '@store/actions/income-net-worth/income-net-worth.actions';
import { StartOverStateCleared } from '@store/actions/start-over/start-over.actions';

export interface FinancialDetailsState {
  annualIncome: string;
  liquidNetWorth: string;
}

export interface FinancialState extends FinancialDetailsState {
  validationStatus: 'VALID' | 'INVALID' | null;
}

export const initialState: FinancialState = {
  annualIncome: '',
  liquidNetWorth: '',
  validationStatus: null,
};

const financialReducer = createReducer(
  initialState,
  on(
    UpdateIncomeNetWorthValidationStatus,
    (state, { payload }): FinancialState => ({
      ...state,
      validationStatus: payload,
    }),
  ),
  on(
    UpdateIncomeNetWorth,
    (state, { payload: { annualIncome, liquidNetWorth } }): FinancialState => ({
      ...state,
      annualIncome,
      liquidNetWorth,
    }),
  ),
  on(StartOverStateCleared, (): FinancialState => ({ ...initialState })),
);

export function reducer(state: FinancialState | undefined, action: Action) {
  return financialReducer(state, action);
}
